import { useSnackbar } from "notistack";
import useLocales from "./useLocales";

const useForbiddenSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { translate } = useLocales();

  const notifyForbidden = (module: string, feature: string) => {
    enqueueSnackbar(
      translate("permission_not_available", {
        module: translate(module),
        feature: translate(feature),
      }),
      { variant: "error" },
    );
  };

  return { notifyForbidden };
};

export default useForbiddenSnackbar;
